/*
 * Pantalla "Criterios IGI": listado de los criterios del Indice de Gestion
 * Integral agrupados por eje. Lee `state.igi_module._get_all_criterios`, cuyo
 * `data` es el objeto `{cantidad, datos}` del backend (estado inicial: `[]`).
 * Con el permiso `igi_manage` muestra la accion Editar (/igi/criterios/editar/:id).
 */
import React, {useEffect, useState} from "react";
import DataTable from "../../../../components/data-table";
import Breadcrumbs from "../../../../components/breadcrumbs";
import {useSelector, useDispatch} from "react-redux";
import {useHistory} from "react-router-dom";
import {get_all_criterios} from "../../../../redux/igi";

/** @module  Pages/Igi/Criterios */

const Criterios = (props) => {
    const dispatch = useDispatch();
    let history = useHistory();
    const {token} = useSelector((state) => state.users_module.login.data) || null;
    const criterios = useSelector((state) => state.igi_module._get_all_criterios);

    const [data, setData] = useState([]);
    const [permisos, setPermisos] = useState([]);
    const [actions, setActions] = useState([]);

    useEffect(() => {
        dispatch(get_all_criterios(token));
    }, [token, dispatch]);

    useEffect(() => {
        if (criterios.data && criterios.data.datos) {
            const filas = [];
            criterios.data.datos.forEach((eje) => {
                eje.criterios.forEach((c) => {
                    filas.push({
                        id: c.id,
                        eje: `${eje.codigo} - ${eje.nombre} (${eje.peso})`,
                        grupo: c.grupo,
                        nombre: c.nombre,
                        orden: c.orden,
                        activo: c.activo,
                    });
                });
            });
            setData(filas);
        }
    }, [criterios]);

    useEffect(() => {
        if (props) {
            setPermisos(Object.values(props));
        }
    }, [props]);

    useEffect(() => {
        let act = [];
        if (permisos.filter(x => x.codigo === 'igi_manage').length > 0) {
            act.push({
                name: "edit",
                label: "Edit",
                icon: "bx bx-edit",
                color: "primary",
                onClick: (item) => {
                    history.push(`/igi/criterios/editar/${item.id}`);
                },
            });
        }
        setActions(act);
    }, [permisos, history]);

    return (
        <div className="app-content content">
            <div className="content-overlay"/>
            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Criterios IGI"
                            items={[{label: "Criterios IGI", link: "/igi/criterios"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {name: "eje", label: "Eje", type: "text"},
                                            {name: "grupo", label: "Grupo", type: "text"},
                                            {name: "nombre", label: "Criterio", type: "text"},
                                            {name: "orden", label: "Orden", type: "text"},
                                            {name: "activo", label: "Activo", type: "boolean"},
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Criterios;
